import { Row, Col, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const { Text } = Typography;



export const EksSummaryPanel = (data) => {

  const { t } = useTranslation();

  const handleNormalUrlClick = (e, url) => {
    e.preventDefault();
    window.open(`${url}`, "_blank");
  };
  
  return (
    <div>
      {Object.entries(data?.data).filter(item => item[0] !== 'nodegroups' && item[0] !== 'region').map(([key, value]) => (
        <Row key={key} style={{ marginBottom: 8 }} align="middle">
          <Col span={4}>
            <Text strong>{t(`eks.fields.${key}`, key)}:</Text>
          </Col>
          <Col span={10}>
            <Text>
                {key === "dashboardURL" ? (
                      <Link
                        to={value}
                        onClick={(e) =>
                          handleNormalUrlClick(e, data.value.dashboardURL)
                        }
                      >
                        {value}
                      </Link>
                ): (
                  value && (
                    <Typography.Text copyable>{value}</Typography.Text>
                  )
                )}
              </Text>
          </Col>
        </Row>
      ))}
    </div>
  );
}; 